import {
  createPaginatedSupabaseQuery,
  createSearchSupabaseQuery,
  spawnCreateApiFunction,
  spawnDeleteApiFunction,
  spawnGetApiFunction,
  spawnListInApiFunction,
  spawnUpdateApiFunction,
  type ApiResourceConfig,
  type SearchOptionFilters,
} from "@/utils/api";

import type { QueryPaginationFilters } from "@/utils/pagination";

const table = "part_models";
const query = `
  *,
  part_manufacturer:part_manufacturers(*),
  part_category:part_categories(*),
  search_m:part_manufacturers(name),
  search_c:part_categories(name),
  parts(count)
`;
export const apiConfigPartModels: ApiResourceConfig<typeof table, typeof query> = {
  table,
  query,
  searchables: [
    "name",
    "description",
    "ref",
    "manufacturer_ref",
    "order_information",
    "supplier",
    "supplier_ref",
    "search_m.name",
    "search_c.name",
  ],
  sortables: [
    "name",
    "created_at",
    "updated_at",
    "ref",
    "manufacturer_ref",
    "order_information",
    "supplier",
    "supplier_ref",
    "part_manufacturer.name",
    "part_category.name",
  ],
};

export const getPartModel = spawnGetApiFunction({ table, query });
export const getPartModelsByIds = spawnListInApiFunction({ table, query });
export const createPartModel = spawnCreateApiFunction({ table, query });
export const updatePartModel = spawnUpdateApiFunction({ table, query });
export const deletePartModel = spawnDeleteApiFunction({ table });

export async function getPaginatedPartModels({
  dataTableOptions,
  customFilters,
  customOrFilters,
}: QueryPaginationFilters) {
  const { data, count, error } = await createPaginatedSupabaseQuery({
    baseOptions: {
      table,
      query,
      searchables: apiConfigPartModels.searchables,
      sortables: apiConfigPartModels.sortables,
    },
    dataTableOptions,
    customFilters,
    customOrFilters,
  });

  if (error) throw error;
  return { data, count };
}

export async function getPartModelsBySearch({
  searchOptions,
  customFilters,
  customOrFilters,
  limit,
}: SearchOptionFilters) {
  const { data, count, error } = await createSearchSupabaseQuery({
    baseOptions: {
      table,
      query,
      searchables: apiConfigPartModels.searchables,
      sortables: apiConfigPartModels.sortables,
    },
    searchOptions,
    customFilters,
    customOrFilters,
    limit,
  });

  if (error) throw error;
  return { data, count };
}
